import React from 'react';
import IconBase from 'react-icons/IconBase';

export const DownloadIcon = props => (
  <IconBase viewBox="0 0 23 20" {...props}>
    <path
      fill="currentColor"
      d="M17.266 4.016c1.554.158 2.786 1.445 2.91 3.052a3.822 3.822 0 012.046 3.408c0 2.104-1.658 3.81-3.704 3.81h-5.092V10.29l2.225 2.452 2.031-1.949-5.645-6.221-5.645 6.221 2.03 1.95 2.226-2.453v3.995h-7.87v-.034C1.208 14.021 0 12.632 0 10.952c0-1.418.86-2.629 2.074-3.11a3.453 3.453 0 01-.037-.509C2.037 5.493 3.487 4 5.277 4c.325 0 .639.05.935.14C6.972 1.737 9.169 0 11.759 0c2.546 0 4.71 1.677 5.507 4.016zM11.111 14.286h1.852V20h-1.852v-5.714z"
    />
  </IconBase>
);
